import { createSlice } from '@reduxjs/toolkit';
import {
  findSelectToppingsCategoryItem,
  searchSelectToppingsCategoryItem,
  getSelectToppingsCategoryItem,
} from './api';
import { initialState } from './api/interface';

const selectToppingCategoryItemSlice = createSlice({
  name: 'selectToppingCategoryItem',
  initialState,
  reducers: {
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
    },
    setHasMore: (state, action) => {
      state.hasMore = action.payload.hasMore;
      state.status = 'idle';
    },

    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findSelectToppingsCategoryItem.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findSelectToppingsCategoryItem.fulfilled, (state, action) => {
      state.data.push(...action.payload.data);
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
      state.hasMore = action.payload.data.length < 10 ? false : true;
    });
    builder.addCase(findSelectToppingsCategoryItem.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
    builder.addCase(searchSelectToppingsCategoryItem.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(searchSelectToppingsCategoryItem.fulfilled, (state, action) => {
      state.data = [...action.payload.data, ...state.data];
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(searchSelectToppingsCategoryItem.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
    builder.addCase(getSelectToppingsCategoryItem.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getSelectToppingsCategoryItem.fulfilled, (state, _) => {
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(getSelectToppingsCategoryItem.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });
  },
});

export const { setSkip, setHasMore, setStatus, reset } =
  selectToppingCategoryItemSlice.actions;
export default selectToppingCategoryItemSlice.reducer;
